import {createTranslationMessages} from '@backstage/core-plugin-api/alpha';
import {catalogTranslationRef} from '@backstage/plugin-catalog/alpha';

export const catalogPtbr = createTranslationMessages({
    ref: catalogTranslationRef,
    messages: {
        "deleteEntity.description": "Esta entidade não está referenciada em nenhum local e, portanto, não está recebendo atualizações. Clique aqui para excluir.",
        "deleteEntity.cancelButtonTitle": "Cancelar",
        "deleteEntity.deleteButtonTitle": "Excluir",
        "deleteEntity.dialogTitle": "Tem certeza que deseja excluir esta entidade?",
        "indexPage.title": "Catálogo {{orgName}}",
        "indexPage.createButtonTitle": "Criar",
        "indexPage.supportButtonContent": "Todas as entidades do catálogo de software",
        "aboutCard.title": "Sobre",
        "aboutCard.refreshButtonTitle": "Agendar atualização da entidade",
        "aboutCard.editButtonTitle": "Editar Metadados",
        "aboutCard.createSimilarButtonTitle": "Criar algo similar",
        "aboutCard.refreshScheduledMessage": "Atualização agendada",
        "aboutCard.launchTemplate": "Iniciar Template",
        "aboutCard.viewTechdocs": "Ver TechDocs",
        "aboutCard.viewSource": "Ver Fonte",
        "aboutCard.descriptionField.value": "Sem descrição",
        "aboutCard.descriptionField.label": "Descrição",
        "aboutCard.ownerField.value": "Sem Proprietário",
        "aboutCard.ownerField.label": "Proprietário",
        "aboutCard.domainField.value": "Sem Domínio",
        "aboutCard.domainField.label": "Domínio",
        "aboutCard.systemField.value": "Sem Sistema",
        "aboutCard.systemField.label": "Sistema",
        "aboutCard.parentComponentField.value": "Sem Componente Pai",
        "aboutCard.parentComponentField.label": "Componente Pai",
        "aboutCard.typeField.label": "Tipo",
        "aboutCard.lifecycleField.label": "Ciclo de Vida",
        "aboutCard.tagsField.value": "Sem Tags",
        "aboutCard.tagsField.label": "Tags",
        "aboutCard.targetsField.label": "Alvos",
        "searchResultItem.lifecycle": "Ciclo de Vida",
        "searchResultItem.Owner": "Proprietário",
        "catalogTable.warningPanelTitle": "Não foi possível buscar as entidades do catálogo.",
        "catalogTable.viewActionTitle": "Visualizar",
        "catalogTable.editActionTitle": "Editar",
        "catalogTable.starActionTitle": "Adicionar aos favoritos",
        "catalogTable.unStarActionTitle": "Remover dos favoritos",
        "dependencyOfComponentsCard.title": "Dependência de componentes",
        "dependencyOfComponentsCard.emptyMessage": "Nenhum componente depende deste componente",
        "dependsOnComponentsCard.title": "Depende de componentes",
        "dependsOnComponentsCard.emptyMessage": "Nenhum componente é dependência deste componente",
        "dependsOnResourcesCard.title": "Depende de recursos",
        "dependsOnResourcesCard.emptyMessage": "Nenhum recurso é dependência deste componente",
        "entityContextMenu.copiedMessage": "Copiado!",
        "entityContextMenu.moreButtonTitle": "Mais",
        "entityContextMenu.inspectMenuTitle": "Inspecionar entidade",
        "entityContextMenu.copyURLMenuTitle": "Copiar URL da entidade",
        "entityContextMenu.unregisterMenuTitle": "Cancelar registro da entidade",
        "entityLabelsCard.title": "Rótulos",
        "entityLabelsCard.emptyDescription": "Nenhum rótulo definido para esta entidade. Você pode adicionar rótulos ao seu YAML de entidade conforme mostrado no exemplo destacado abaixo:",
        "entityLabelsCard.readMoreButtonTitle": "Leia mais",
        "entityLabels.warningPanelTitle": "Entidade não encontrada",
        "entityLabels.ownerLabel": "Proprietário",
        "entityLabels.lifecycleLabel": "Ciclo de Vida",
        "entityLinksCard.title": "Links",
        "entityLinksCard.emptyDescription": "Nenhum link definido para esta entidade. Você pode adicionar links ao seu YAML de entidade conforme mostrado no exemplo destacado abaixo:",
        "entityLinksCard.readMoreButtonTitle": "Leia mais",
        "entityNotFound.title": "Entidade não encontrada",
        "entityNotFound.description": "Quer nos ajudar a construir isso? Confira nossa documentação de Primeiros Passos.",
        "entityNotFound.docButtonTitle": "DOCUMENTAÇÃO",
        entityProcessingErrorsDescription: "O erro abaixo origina-se de",
        entityRelationWarningDescription: "Esta entidade tem relações com outras entidades que não podem ser encontradas no catálogo.\n Entidades não encontradas são: ",
        "hasComponentsCard.title": "Possui componentes",
        "hasComponentsCard.emptyMessage": "Nenhum componente faz parte deste sistema",
        "hasResourcesCard.title": "Possui recursos",
        "hasResourcesCard.emptyMessage": "Nenhum recurso faz parte deste sistema",
        "hasSubcomponentsCard.title": "Possui subcomponentes",
        "hasSubcomponentsCard.emptyMessage": "Nenhum subcomponente faz parte deste componente",
        "hasSubdomainsCard.title": "Possui subdomínios",
        "hasSubdomainsCard.emptyMessage": "Nenhum subdomínio faz parte deste domínio",
        "hasSystemsCard.title": "Possui sistemas",
        "hasSystemsCard.emptyMessage": "Nenhum sistema faz parte deste domínio",
        "relatedEntitiesCard.emptyHelpLinkTitle": "Aprenda como alterar isso",
        "systemDiagramCard.title": "Diagrama do Sistema",
        "systemDiagramCard.description": "Use pinça e zoom para mover pelo diagrama.",
        "systemDiagramCard.edgeLabels.dependsOn": "depende de",
        "systemDiagramCard.edgeLabels.partOf": "parte de",
        "systemDiagramCard.edgeLabels.provides": "fornece",
    },
});

export default catalogPtbr;
